export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-spotify-2cb9b2120e70679192931e6325571325.svg";